<template>
    <div class="map">
        <div class="mapBox">
            <img class="mapBG" @load="isLoad()" src="../../public/img/mapBG.jpg" alt="" srcset="">
            <transition name="showstart">
                <img class="icon" v-show="star1" style="left:46.4%;top:30.4%" src="../../public/img/star.png" alt="">   
            </transition>
            <transition name="showstart">
                <img class="icon" v-show="star2" style="left:46.9%;top:36.4%" src="../../public/img/star.png" alt="">    
            </transition>    
            <transition name="showstart">       
                <img class="icon" v-show="star3" style="left:48.6%;top:33.2%" src="../../public/img/star.png" alt="">               
            </transition>    
            <transition name="showstart">   
                <img class="icon" v-show="star4" style="left:79.3%;top:45.9%" src="../../public/img/star.png" alt="">  
            </transition>  
            <transition name="showstart">                
                <img class="icon" v-show="star5" style="left:78.5%;top:51.9%" src="../../public/img/star.png" alt="">     
            </transition>
            <transition name="showstart">                
                <img class="icon" v-show="pos1" style="left:78.5%;top:39.8%" src="../../public/img/pos.png" alt=""> 
            </transition>  
            <transition name="showstart">    
                <img class="icon" v-show="pos2" style="left:76.7%;top:45.9%" src="../../public/img/pos.png" alt=""> 
            </transition>   
            <transition name="fade">    
                <div class="cricle" v-show="cricle1" style="top:28%;left:51%;">
                    <img :src="`${baseUrl}img/cricle1${lang}.png`" width="100%" alt="" srcset="">
                </div>
            </transition>   
            <transition name="fade">    
                <div class="cricle" v-show="cricle2" style="top:40.1%;left:77.1%;">
                    <img :src="`${baseUrl}img/cricle2${lang}.png`" width="100%" alt="" srcset="">
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            star1:false,
            star2:false,
            star3:false,
            star4:false,
            star5:false,
            pos1:false,
            pos2:false,
            cricle1:false,
            cricle2:false,
            isLoadImg:false,
            lang:'',
            baseUrl:process.env.BASE_URL, 
        }
    },
    methods:{
       isLoad(){
            this.isLoadImg = true
            this.start()        
       },
       start(){
           this.star1 = true
           setTimeout(()=>{
               this.star2 = true
               this.star4 = true
           },300)
           setTimeout(()=>{
               this.star3 = true
               this.star5 = true
               this.pos1 = true               
           },600)
           setTimeout(()=>{
               this.pos2 = true
               this.cricle1 = true
           },900)
           setTimeout(()=>{
               this.cricle2 = true
           },1200)
       }
    },
    watch:{
        '$i18n.locale'(){
            console.log()
            if(this.$i18n.locale=='en'){
                this.lang = 'EN'
            }else{
                this.lang = ''
            }
        },
    },
    mounted(){
        if(this.isLoadImg){
            this.start()
        }
    }
}
</script>
<style lang="less">
.map{
    .mapBox{
        width: 60%;
        position: relative;            
        margin: 0 auto;
        .icon{
            width: 1.5%;
            position: absolute;
            transform: translate(-50%,-50%);
        }
        .cricle{
            width: 22%;
            position: absolute;
            transition: 0.3s all linear;
            transform: translate(-50%,-50%);
        }
        .cricle:hover{
            transform: translate(-50%,-50%) scale(1.1);
        }
    }
    .mapBG{
        width: 60vw;
        display: block;
    }
    .showstart-enter-active, .showstart-leave-active {
        animation: show-in 1s;
        transition: 0.3s linear;
    }
    .showstart-enter, .showstart-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    @keyframes show-in {
        0%{
            transform: translate(-50%,-100px);
        }
        100%{
            transform: translate(-50%,-50%);
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: all .4s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        transform: translate(0,50%);
    }
}
</style>

